import { render, staticRenderFns } from "./SimpleCheckboxComponent.vue?vue&type=template&id=6ba3d4b4&"
import script from "./SimpleCheckboxComponent.vue?vue&type=script&lang=js&"
export * from "./SimpleCheckboxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ba3d4b4')) {
      api.createRecord('6ba3d4b4', component.options)
    } else {
      api.reload('6ba3d4b4', component.options)
    }
    module.hot.accept("./SimpleCheckboxComponent.vue?vue&type=template&id=6ba3d4b4&", function () {
      api.rerender('6ba3d4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/commons/SimpleCheckboxComponent.vue"
export default component.exports